import axios from "axios";

import { LOGIN_SUCCESS, LOGOUT_SUCCESS, AUTH_FAIL, ADMIN_LOADED,GET_SETTINGS } from "../actions";

import { store } from "../index";
import { openSnackbar } from "store/slices/snackbar";
import setAuthToken from "../../Helpers/setAuthToken";


const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const PROXY = process.env.REACT_APP_URL;

// Error handling for axios requests in case of 401 status code (Unauthorized)
axios.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error?.response?.status === 401 || error?.response?.status === 403) {
      store.dispatch({
        type: AUTH_FAIL,
      });
      store.dispatch(
        openSnackbar({
          open: true,
          message: error?.response?.data?.message ? error?.response?.data?.message : "Authentication failed. Please try again.",
          variant: 'alert',
          alert: {
            color: "error",
          },
          transition: 'Fade',
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          severity: "info",
        })
      )
    }
    return Promise.reject(error);
  }
);

export const login = (userObj) => async (dispatch) => {
  try {
    const body = JSON.stringify(userObj);

    const res = await axios.post(PROXY + "login", body, config);
    // console.log("res of login action : ", res);

    if (res && res?.data && res?.status === 200) {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      });
      // console.log("else part ## ");
      dispatch(loadUser());
    }
    return res
  } catch (error) {

    return error.response;
  }
};

// Load User / AUTH API
export const loadUser = (data) => async (dispatch) => {
  
  if (localStorage.MILITARY_USER_TOKEN) {
    setAuthToken(localStorage.MILITARY_USER_TOKEN);
  }
  try {
    const body = JSON.stringify(data);
    const res = await axios.get(PROXY + "user/user-auth", body, config);

    dispatch({
      type: ADMIN_LOADED,
      payload: res.data.result,
    });

    return res.data.result;
  } catch (error) {
    console.log("auth still fail", error);
    dispatch({
      type: AUTH_FAIL,
    });
  }
};

export const logout = () => async (dispatch) => {
  dispatch({
    type: LOGOUT_SUCCESS,
  });
};

export const RegisterUser= (data) => async () => {
   
    return await axios.post(`${PROXY}register`, data);
  };

export const changeUserPassword = (data) => async (dispatch) => {
    try {
  const body = JSON.stringify(data);
  const res = await axios.put(`${PROXY}user/change-password`, body, config);



  return res;
    }catch(error){
        return error.response
    }
};

export const updateUserProfileData = (formData) => async (dispatch) => {


  const res = await axios.put(`${PROXY}user/update`, formData);
  return res;
};

export const getDropdownData = () => async (dispatch) => {


  const res = await axios.get(`${PROXY}user/user-service`);
  return res;
};

export const forgotPassword = (objPassword) => async (dispatch) => {
  const body = JSON.stringify(objPassword);

  const res = await axios.post(
    PROXY + "forgot-password" ,
    body,
    config
  );

  return res;
};

export const updateProfile = (id, formData) => async (dispatch) => {
  return await axios.put(PROXY + "admin/update-profile", formData);
};

export const SendCodeMailForRegister = (data) => async () => {
  try {
 const res= await axios.post(`${PROXY}send-mail`, data);
 return res
  }catch(err){
    return err.response
  }
};

export const VerifyOtp = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}check-otp`, data);
  return res;
};

export const ContactUs = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}user/contact-us`, data);
  return res;
};
export const DeleteAccount = (data) => async (dispatch) => {
  const res = await axios.delete(`${PROXY}user/delete`, data);
  return res;
};
export const getSettings=()=>async(dispatch)=>{


  try {

    const res = await axios.get(PROXY + "setting/get-links",  config);

    dispatch({
      type: GET_SETTINGS,
      payload: res.data.result,
    });

    return res.data.result;
  } catch (error) {
   return error
  
  }

}